import { createSlice } from '@reduxjs/toolkit'
import { updateWorkspaceOpenAiSettings } from '../../../components/workspace/settings/open-ai/slice'
import { resetErrors, resetStatus } from '../../reducer-helper'

const initialState = {
  settings: {
    apiKey: '',
    organization: '',
  },
  formLoaded: false,
  error: null,
  status: null,
}

const slice = createSlice({
  name: 'workspaceOpenAiSettingsForm',
  initialState,
  reducers: {
    changeApiKey: (state, action) => {
      state.settings.apiKey = action.payload.apiKey
    },
    changeOrganization: (state, action) => {
      state.settings.organization = action.payload.organization
    },
    changeRequestStatus: (state, action) => {
      state.status = action.payload.status
    },
    setSettings: (state, action) => {
      state.settings.apiKey = action.payload.apiKey
      state.settings.organization = action.payload.organization

      state.formLoaded = true
    },
    resetForm: () => initialState,
  },
  extraReducers(builder) {
    builder.addCase(updateWorkspaceOpenAiSettings.fulfilled, (state, action) => {
      resetStatus(state)
      resetErrors(state)
    })
  },
})

const selectSlice = (state) => state.workspaceOpenAiSettingsForm
export const selectSettings = (state) => selectSlice(state).settings
export const selectError = (state) => selectSlice(state).error
export const selectRequestStatus = (state) => selectSlice(state).status

const { reducer, actions } = slice

export const { changeApiKey, changeOrganization, setSettings, resetForm, changeRequestStatus } = actions

export default reducer
